import { StyledSpinner } from './ButtonSpinner.styles';

const ButtonSpinnerDisabledPurple = () => {
  return (
    <StyledSpinner src="/svg/loading_disabled_purple.svg" alt="Spinner icon" aria-label="Loading" />
  );
};

export default ButtonSpinnerDisabledPurple;
